import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isToolHiddenForRole } from '../config/marketingTools';

// Sends roles that should not see a tool back to the Tools page.
export default function ToolRoleGate({ children }) {
  const { userRole } = useAuth();
  const { pathname } = useLocation();
  if (isToolHiddenForRole(userRole, pathname)) return <Navigate to="/tools" replace />;
  return children;
}
